import {Component, OnInit, Input, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BasicModalModule} from '../../shared/modules/modals/basic-modal/basic-modal.module';

@Component({
  selector: 'app-modal-ok-singup',
  templateUrl: './modal-ok-singup.component.html',
  styleUrls: ['./modal-ok-singup.component.scss'],
})
export class ModalOkSingupComponent implements OnInit {
  @Input() modalOkSingUp: any;

  ngOnInit() {}

  reloadPage() {
    window.location.reload();
  }
}

@NgModule({
  declarations: [ModalOkSingupComponent],
  exports: [ModalOkSingupComponent],
  imports: [
    CommonModule,
    BasicModalModule,
  ],
})
export class ModalOkSingupModule { }
